// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * jQuery UI CSS Framework 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/theming/
 */
.ui-draggable-handle {
	-ms-touch-action: none;
	touch-action: none;
}
/* Layout helpers
----------------------------------*/
.ui-helper-hidden {
	display: none;
}
.ui-helper-hidden-accessible {
	border: 0;
	clip: rect(0 0 0 0);
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	width: 1px;
}
.ui-helper-reset {
	margin: 0;
	padding: 0;
	border: 0;
	outline: 0;
	line-height: 1.3;
	text-decoration: none;
	font-size: 100%;
	list-style: none;
}
.ui-helper-clearfix:before,
.ui-helper-clearfix:after {
	content: "";
	display: table;
	border-collapse: collapse;
}
.ui-helper-clearfix:after {
	clear: both;
}
.ui-helper-zfix {
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	position: absolute;
	opacity: 0;
	filter:Alpha(Opacity=0); /* support: IE8 */
}

.ui-front {
	z-index: 100;
}


/* Interaction Cues
----------------------------------*/
.ui-state-disabled {
	cursor: default !important;
	pointer-events: none;
}


/* Icons
----------------------------------*/
.ui-icon {
	display: inline-block;
	vertical-align: middle;
	margin-top: -.25em;
	position: relative;
	text-indent: -99999px;
	overflow: hidden;
	background-repeat: no-repeat;
}

.ui-widget-icon-block {
	left: 50%;
	margin-left: -8px;
	display: block;
}

/* Misc visuals
----------------------------------*/

/* Overlays */
.ui-widget-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
.ui-resizable {
	position: relative;
}
.ui-resizable-handle {
	position: absolute;
	font-size: 0.1px;
	display: block;
	-ms-touch-action: none;
	touch-action: none;
}
.ui-resizable-disabled .ui-resizable-handle,
.ui-resizable-autohide .ui-resizable-handle {
	display: none;
}
.ui-resizable-n {
	cursor: n-resize;
	height: 7px;
	width: 100%;
	top: -5px;
	left: 0;
}
.ui-resizable-s {
	cursor: s-resize;
	height: 7px;
	width: 100%;
	bottom: -5px;
	left: 0;
}
.ui-resizable-e {
	cursor: e-resize;
	width: 7px;
	right: -5px;
	top: 0;
	height: 100%;
}
.ui-resizable-w {
	cursor: w-resize;
	width: 7px;
	left: -5px;
	top: 0;
	height: 100%;
}
.ui-resizable-se {
	cursor: se-resize;
	width: 12px;
	height: 12px;
	right: 1px;
	bottom: 1px;
}
.ui-resizable-sw {
	cursor: sw-resize;
	width: 9px;
	height: 9px;
	left: -5px;
	bottom: -5px;
}
.ui-resizable-nw {
	cursor: nw-resize;
	width: 9px;
	height: 9px;
	left: -5px;
	top: -5px;
}
.ui-resizable-ne {
	cursor: ne-resize;
	width: 9px;
	height: 9px;
	right: -5px;
	top: -5px;
}
.ui-selectable {
	-ms-touch-action: none;
	touch-action: none;
}
.ui-selectable-helper {
	position: absolute;
	z-index: 100;
	border: 1px dotted black;
}
.ui-sortable-handle {
	-ms-touch-action: none;
	touch-action: none;
}
.ui-accordion .ui-accordion-header {
	display: block;
	cursor: pointer;
	position: relative;
	margin: 2px 0 0 0;
	padding: .5em .5em .5em .7em;
	font-size: 100%;
}
.ui-accordion .ui-accordion-content {
	padding: 1em 2.2em;
	border-top: 0;
	overflow: auto;
}
.ui-autocomplete {
	position: absolute;
	top: 0;
	left: 0;
	cursor: default;
}
.ui-menu {
	list-style: none;
	padding: 0;
	margin: 0;
	display: block;
	outline: 0;
}
.ui-menu .ui-menu {
	position: absolute;
}
.ui-menu .ui-menu-item {
	margin: 0;
	cursor: pointer;
	/* support: IE10, see #8844 */
	list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.ui-menu .ui-menu-item-wrapper {
	position: relative;
	padding: 3px 1em 3px .4em;
}
.ui-menu .ui-menu-divider {
	margin: 5px 0;
	height: 0;
	font-size: 0;
	line-height: 0;
	border-width: 1px 0 0 0;
}
.ui-menu .ui-state-focus,
.ui-menu .ui-state-active {
	margin: -1px;
}

/* icon support */
.ui-menu-icons {
	position: relative;
}
.ui-menu-icons .ui-menu-item-wrapper {
	padding-left: 2em;
}

/* left-aligned */
.ui-menu .ui-icon {
	position: absolute;
	top: 0;
	bottom: 0;
	left: .2em;
	margin: auto 0;
}

/* right-aligned */
.ui-menu .ui-menu-icon {
	left: auto;
	right: 0;
}
.ui-button {
	padding: .4em 1em;
	display: inline-block;
	position: relative;
	line-height: normal;
	margin-right: .1em;
	cursor: pointer;
	vertical-align: middle;
	text-align: center;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	/* Support: IE <= 11 */
	overflow: visible;
}

.ui-button,
.ui-button:link,
.ui-button:visited,
.ui-button:hover,
.ui-button:active {
	text-decoration: none;
}

/* to make room for the icon, a width needs to be set here */
.ui-button-icon-only {
	width: 2em;
	box-sizing: border-box;
	text-indent: -9999px;
	white-space: nowrap;
}

/* no icon support for input elements */
input.ui-button.ui-button-icon-only {
	text-indent: 0;
}

/* button icon element(s) */
.ui-button-icon-only .ui-icon {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -8px;
	margin-left: -8px;
}

.ui-button.ui-icon-notext .ui-icon {
	padding: 0;
	width: 2.1em;
	height: 2.1em;
	text-indent: -9999px;
	white-space: nowrap;

}

input.ui-button.ui-icon-notext .ui-icon {
	width: auto;
	height: auto;
	text-indent: 0;
	white-space: normal;
	padding: .4em 1em;
}

/* workarounds */
/* Support: Firefox 5 - 40 */
input.ui-button::-moz-focus-inner,
button.ui-button::-moz-focus-inner {
	border: 0;
	padding: 0;
}
.ui-controlgroup {
	vertical-align: middle;
	display: inline-block;
}
.ui-controlgroup > .ui-controlgroup-item {
	float: left;
	margin-left: 0;
	margin-right: 0;
}
.ui-controlgroup > .ui-controlgroup-item:focus,
.ui-controlgroup > .ui-controlgroup-item.ui-visual-focus {
	z-index: 9999;
}
.ui-controlgroup-vertical > .ui-controlgroup-item {
	display: block;
	float: none;
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	text-align: left;
}
.ui-controlgroup-vertical .ui-controlgroup-item {
	box-sizing: border-box;
}
.ui-controlgroup .ui-controlgroup-label {
	padding: .4em 1em;
}
.ui-controlgroup .ui-controlgroup-label span {
	font-size: 80%;
}
.ui-controlgroup-horizontal .ui-controlgroup-label + .ui-controlgroup-item {
	border-left: none;
}
.ui-controlgroup-vertical .ui-controlgroup-label + .ui-controlgroup-item {
	border-top: none;
}
.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {
	border-right: none;
}
.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {
	border-bottom: none;
}

/* Spinner specific style fixes */
.ui-controlgroup-vertical .ui-spinner-input {

	/* Support: IE8 only, Android < 4.4 only */
	width: 75%;
	width: calc( 100% - 2.4em );
}
.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {
	border-top-style: solid;
}

.ui-checkboxradio-label .ui-icon-background {
	box-shadow: inset 1px 1px 1px #ccc;
	border-radius: .12em;
	border: none;
}
.ui-checkboxradio-radio-label .ui-icon-background {
	width: 16px;
	height: 16px;
	border-radius: 1em;
	overflow: visible;
	border: none;
}
.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,
.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {
	background-image: none;
	width: 8px;
	height: 8px;
	border-width: 4px;
	border-style: solid;
}
.ui-checkboxradio-disabled {
	pointer-events: none;
}
.ui-datepicker {
	width: 17em;
	padding: .2em .2em 0;
	display: none;
}
.ui-datepicker .ui-datepicker-header {
	position: relative;
	padding: .2em 0;
}
.ui-datepicker .ui-datepicker-prev,
.ui-datepicker .ui-datepicker-next {
	position: absolute;
	top: 2px;
	width: 1.8em;
	height: 1.8em;
}
.ui-datepicker .ui-datepicker-prev-hover,
.ui-datepicker .ui-datepicker-next-hover {
	top: 1px;
}
.ui-datepicker .ui-datepicker-prev {
	left: 2px;
}
.ui-datepicker .ui-datepicker-next {
	right: 2px;
}
.ui-datepicker .ui-datepicker-prev-hover {
	left: 1px;
}
.ui-datepicker .ui-datepicker-next-hover {
	right: 1px;
}
.ui-datepicker .ui-datepicker-prev span,
.ui-datepicker .ui-datepicker-next span {
	display: block;
	position: absolute;
	left: 50%;
	margin-left: -8px;
	top: 50%;
	margin-top: -8px;
}
.ui-datepicker .ui-datepicker-title {
	margin: 0 2.3em;
	line-height: 1.8em;
	text-align: center;
}
.ui-datepicker .ui-datepicker-title select {
	font-size: 1em;
	margin: 1px 0;
}
.ui-datepicker select.ui-datepicker-month,
.ui-datepicker select.ui-datepicker-year {
	width: 45%;
}
.ui-datepicker table {
	width: 100%;
	font-size: .9em;
	border-collapse: collapse;
	margin: 0 0 .4em;
}
.ui-datepicker th {
	padding: .7em .3em;
	text-align: center;
	font-weight: bold;
	border: 0;
}
.ui-datepicker td {
	border: 0;
	padding: 1px;
}
.ui-datepicker td span,
.ui-datepicker td a {
	display: block;
	padding: .2em;
	text-align: right;
	text-decoration: none;
}
.ui-datepicker .ui-datepicker-buttonpane {
	background-image: none;
	margin: .7em 0 0 0;
	padding: 0 .2em;
	border-left: 0;
	border-right: 0;
	border-bottom: 0;
}
.ui-datepicker .ui-datepicker-buttonpane button {
	float: right;
	margin: .5em .2em .4em;
	cursor: pointer;
	padding: .2em .6em .3em .6em;
	width: auto;
	overflow: visible;
}
.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {
	float: left;
}

/* with multiple calendars */
.ui-datepicker.ui-datepicker-multi {
	width: auto;
}
.ui-datepicker-multi .ui-datepicker-group {
	float: left;
}
.ui-datepicker-multi .ui-datepicker-group table {
	width: 95%;
	margin: 0 auto .4em;
}
.ui-datepicker-multi-2 .ui-datepicker-group {
	width: 50%;
}
.ui-datepicker-multi-3 .ui-datepicker-group {
	width: 33.3%;
}
.ui-datepicker-multi-4 .ui-datepicker-group {
	width: 25%;
}
.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {
	border-left-width: 0;
}
.ui-datepicker-multi .ui-datepicker-buttonpane {
	clear: left;
}
.ui-datepicker-row-break {
	clear: both;
	width: 100%;
	font-size: 0;
}

/* RTL support */
.ui-datepicker-rtl {
	direction: rtl;
}
.ui-datepicker-rtl .ui-datepicker-prev {
	right: 2px;
	left: auto;
}
.ui-datepicker-rtl .ui-datepicker-next {
	left: 2px;
	right: auto;
}
.ui-datepicker-rtl .ui-datepicker-prev:hover {
	right: 1px;
	left: auto;
}
.ui-datepicker-rtl .ui-datepicker-next:hover {
	left: 1px;
	right: auto;
}
.ui-datepicker-rtl .ui-datepicker-buttonpane {
	clear: right;
}
.ui-datepicker-rtl .ui-datepicker-buttonpane button {
	float: left;
}
.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,
.ui-datepicker-rtl .ui-datepicker-group {
	float: right;
}
.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {
	border-right-width: 0;
	border-left-width: 1px;
}

/* Icons */
.ui-datepicker .ui-icon {
	display: block;
	text-indent: -99999px;
	overflow: hidden;
	background-repeat: no-repeat;
	left: .5em;
	top: .3em;
}
.ui-dialog {
	position: absolute;
	top: 0;
	left: 0;
	padding: .2em;
	outline: 0;
}
.ui-dialog .ui-dialog-titlebar {
	padding: .4em 1em;
	position: relative;
}
.ui-dialog .ui-dialog-title {
	float: left;
	margin: .1em 0;
	white-space: nowrap;
	width: 90%;
	overflow: hidden;
	text-overflow: ellipsis;
}
.ui-dialog .ui-dialog-titlebar-close {
	position: absolute;
	right: .3em;
	top: 50%;
	width: 20px;
	margin: -10px 0 0 0;
	padding: 1px;
	height: 20px;
}
.ui-dialog .ui-dialog-content {
	position: relative;
	border: 0;
	padding: .5em 1em;
	background: none;
	overflow: auto;
}
.ui-dialog .ui-dialog-buttonpane {
	text-align: left;
	border-width: 1px 0 0 0;
	background-image: none;
	margin-top: .5em;
	padding: .3em 1em .5em .4em;
}
.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {
	float: right;
}
.ui-dialog .ui-dialog-buttonpane button {
	margin: .5em .4em .5em 0;
	cursor: pointer;
}
.ui-dialog .ui-resizable-n {
	height: 2px;
	top: 0;
}
.ui-dialog .ui-resizable-e {
	width: 2px;
	right: 0;
}
.ui-dialog .ui-resizable-s {
	height: 2px;
	bottom: 0;
}
.ui-dialog .ui-resizable-w {
	width: 2px;
	left: 0;
}
.ui-dialog .ui-resizable-se,
.ui-dialog .ui-resizable-sw,
.ui-dialog .ui-resizable-ne,
.ui-dialog .ui-resizable-nw {
	width: 7px;
	height: 7px;
}
.ui-dialog .ui-resizable-se {
	right: 0;
	bottom: 0;
}
.ui-dialog .ui-resizable-sw {
	left: 0;
	bottom: 0;
}
.ui-dialog .ui-resizable-ne {
	right: 0;
	top: 0;
}
.ui-dialog .ui-resizable-nw {
	left: 0;
	top: 0;
}
.ui-draggable .ui-dialog-titlebar {
	cursor: move;
}
.ui-progressbar {
	height: 2em;
	text-align: left;
	overflow: hidden;
}
.ui-progressbar .ui-progressbar-value {
	margin: -1px;
	height: 100%;
}
.ui-progressbar .ui-progressbar-overlay {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	height: 100%;
	filter: alpha(opacity=25); /* support: IE8 */
	opacity: 0.25;
}
.ui-progressbar-indeterminate .ui-progressbar-value {
	background-image: none;
}
.ui-selectmenu-menu {
	padding: 0;
	margin: 0;
	position: absolute;
	top: 0;
	left: 0;
	display: none;
}
.ui-selectmenu-menu .ui-menu {
	overflow: auto;
	overflow-x: hidden;
	padding-bottom: 1px;
}
.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {
	font-size: 1em;
	font-weight: bold;
	line-height: 1.5;
	padding: 2px 0.4em;
	margin: 0.5em 0 0 0;
	height: auto;
	border: 0;
}
.ui-selectmenu-open {
	display: block;
}
.ui-selectmenu-text {
	display: block;
	margin-right: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
}
.ui-selectmenu-button.ui-button {
	text-align: left;
	white-space: nowrap;
	width: 14em;
}
.ui-selectmenu-icon.ui-icon {
	float: right;
	margin-top: 0;
}
.ui-slider {
	position: relative;
	text-align: left;
}
.ui-slider .ui-slider-handle {
	position: absolute;
	z-index: 2;
	width: 1.2em;
	height: 1.2em;
	cursor: default;
	-ms-touch-action: none;
	touch-action: none;
}
.ui-slider .ui-slider-range {
	position: absolute;
	z-index: 1;
	font-size: .7em;
	display: block;
	border: 0;
	background-position: 0 0;
}

/* support: IE8 - See #6727 */
.ui-slider.ui-state-disabled .ui-slider-handle,
.ui-slider.ui-state-disabled .ui-slider-range {
	filter: inherit;
}

.ui-slider-horizontal {
	height: .8em;
}
.ui-slider-horizontal .ui-slider-handle {
	top: -.3em;
	margin-left: -.6em;
}
.ui-slider-horizontal .ui-slider-range {
	top: 0;
	height: 100%;
}
.ui-slider-horizontal .ui-slider-range-min {
	left: 0;
}
.ui-slider-horizontal .ui-slider-range-max {
	right: 0;
}

.ui-slider-vertical {
	width: .8em;
	height: 100px;
}
.ui-slider-vertical .ui-slider-handle {
	left: -.3em;
	margin-left: 0;
	margin-bottom: -.6em;
}
.ui-slider-vertical .ui-slider-range {
	left: 0;
	width: 100%;
}
.ui-slider-vertical .ui-slider-range-min {
	bottom: 0;
}
.ui-slider-vertical .ui-slider-range-max {
	top: 0;
}
.ui-spinner {
	position: relative;
	display: inline-block;
	overflow: hidden;
	padding: 0;
	vertical-align: middle;
}
.ui-spinner-input {
	border: none;
	background: none;
	color: inherit;
	padding: .222em 0;
	margin: .2em 0;
	vertical-align: middle;
	margin-left: .4em;
	margin-right: 2em;
}
.ui-spinner-button {
	width: 1.6em;
	height: 50%;
	font-size: .5em;
	padding: 0;
	margin: 0;
	text-align: center;
	position: absolute;
	cursor: default;
	display: block;
	overflow: hidden;
	right: 0;
}
/* more specificity required here to override default borders */
.ui-spinner a.ui-spinner-button {
	border-top-style: none;
	border-bottom-style: none;
	border-right-style: none;
}
.ui-spinner-up {
	top: 0;
}
.ui-spinner-down {
	bottom: 0;
}
.ui-tabs {
	position: relative;/* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as "fixed") */
	padding: .2em;
}
.ui-tabs .ui-tabs-nav {
	margin: 0;
	padding: .2em .2em 0;
}
.ui-tabs .ui-tabs-nav li {
	list-style: none;
	float: left;
	position: relative;
	top: 0;
	margin: 1px .2em 0 0;
	border-bottom-width: 0;
	padding: 0;
	white-space: nowrap;
}
.ui-tabs .ui-tabs-nav .ui-tabs-anchor {
	float: left;
	padding: .5em 1em;
	text-decoration: none;
}
.ui-tabs .ui-tabs-nav li.ui-tabs-active {
	margin-bottom: -1px;
	padding-bottom: 1px;
}
.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {
	cursor: text;
}
.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {
	cursor: pointer;
}
.ui-tabs .ui-tabs-panel {
	display: block;
	border-width: 0;
	padding: 1em 1.4em;
	background: none;
}
.ui-tooltip {
	padding: 8px;
	position: absolute;
	z-index: 9999;
	max-width: 300px;
}
body .ui-tooltip {
	border-width: 2px;
}
`, "",{"version":3,"sources":["webpack://./assets/jquery-ui/css/jquery-ui.structure.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;CACC,sBAAsB;CACtB,kBAAkB;AACnB;AACA;mCACmC;AACnC;CACC,aAAa;AACd;AACA;CACC,SAAS;CACT,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,SAAS;CACT,UAAU;CACV,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,qBAAqB;CACrB,eAAe;CACf,gBAAgB;AACjB;AACA;;CAEC,WAAW;CACX,cAAc;CACd,yBAAyB;AAC1B;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;CACX,YAAY;CACZ,MAAM;CACN,OAAO;CACP,kBAAkB;CAClB,UAAU;CACV,uBAAuB,EAAE,iBAAiB;AAC3C;;AAEA;CACC,YAAY;AACb;;;AAGA;mCACmC;AACnC;CACC,0BAA0B;CAC1B,oBAAoB;AACrB;;;AAGA;mCACmC;AACnC;CACC,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,SAAS;CACT,iBAAiB;CACjB,cAAc;AACf;;AAEA;mCACmC;;AAEnC,aAAa;AACb;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;AACb;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,aAAa;AACd;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,WAAW;CACX,SAAS;CACT,OAAO;AACR;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,OAAO;AACR;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,WAAW;CACX,MAAM;CACN,YAAY;AACb;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,UAAU;CACV,MAAM;CACN,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;CACX,UAAU;CACV,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;CACX,UAAU;CACV,SAAS;AACV;AACA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;CACX,WAAW;CACX,SAAS;AACV;AACA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,wBAAwB;AACzB;AACA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,4BAA4B;CAC5B,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,SAAS;CACT,cAAc;CACd,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;AACA;CACC,SAAS;CACT,eAAe;CACf,6BAA6B;CAC7B,yDAAuG;AACxG;AACA;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC,aAAa;CACb,SAAS;CACT,YAAY;CACZ,cAAc;CACd,uBAAuB;AACxB;AACA;;CAEC,YAAY;AACb;;AAEA,iBAAiB;AACjB;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;;AAEA,iBAAiB;AACjB;CACC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,UAAU;CACV,cAAc;AACf;;AAEA,kBAAkB;AAClB;CACC,UAAU;CACV,QAAQ;AACT;AACA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,sBAAsB;CACtB,kBAAkB;CAClB,yBAAyB;CACzB,sBAAsB;CACtB,qBAAqB;CACrB,iBAAiB;;CAEjB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;;;;;CAKC,qBAAqB;AACtB;;AAEA,4DAA4D;AAC5D;CACC,UAAU;CACV,sBAAsB;CACtB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA,uCAAuC;AACvC;CACC,cAAc;AACf;;AAEA,2BAA2B;AAC3B;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,aAAa;CACb,oBAAoB;CACpB,mBAAmB;;AAEpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA,gBAAgB;AAChB,4BAA4B;AAC5B;;CAEC,SAAS;CACT,UAAU;AACX;AACA;CACC,sBAAsB;CACtB,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,cAAc;CACd,eAAe;AAChB;AACA;;CAEC,aAAa;AACd;AACA;CACC,cAAc;CACd,WAAW;CACX,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;;AAEA,iCAAiC;AACjC;;CAEC,0CAA0C;CAC1C,UAAU;CACV,2BAA2B;AAC5B;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,kCAAkC;CAClC,oBAAoB;CACpB,YAAY;AACb;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;AACb;AACA;;CAEC,sBAAsB;CACtB,UAAU;CACV,WAAW;CACX,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,WAAW;CACX,oBAAoB;CACpB,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,eAAe;AAChB;AACA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,aAAa;AACd;AACA;;CAEC,QAAQ;AACT;AACA;CACC,SAAS;AACV;AACA;CACC,UAAU;AACX;AACA;CACC,SAAS;AACV;AACA;CACC,UAAU;AACX;AACA;;CAEC,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,QAAQ;CACR,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,aAAa;AACd;AACA;;CAEC,UAAU;AACX;AACA;CACC,WAAW;CACX,eAAe;CACf,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,SAAS;AACV;AACA;CACC,SAAS;CACT,YAAY;AACb;AACA;;CAEC,cAAc;CACd,aAAa;CACb,iBAAiB;CACjB,qBAAqB;AACtB;AACA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,sBAAsB;CACtB,eAAe;CACf,4BAA4B;CAC5B,WAAW;CACX,iBAAiB;AAClB;AACA;CACC,WAAW;AACZ;;AAEA,4BAA4B;AAC5B;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,UAAU;AACX;AACA;CACC,YAAY;AACb;AACA;CACC,UAAU;AACX;AACA;;CAEC,oBAAoB;AACrB;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;CACX,WAAW;CACX,YAAY;AACb;;AAEA,gBAAgB;AAChB;CACC,cAAc;AACf;AACA;CACC,UAAU;CACV,UAAU;AACX;AACA;CACC,SAAS;CACT,WAAW;AACZ;AACA;CACC,UAAU;CACV,UAAU;AACX;AACA;CACC,SAAS;CACT,WAAW;AACZ;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;AACZ;AACA;;CAEC,YAAY;AACb;AACA;;CAEC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA,UAAU;AACV;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,4BAA4B;CAC5B,UAAU;CACV,SAAS;AACV;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,aAAa;CACb,UAAU;AACX;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,cAAc;CACd,mBAAmB;CACnB,UAAU;CACV,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,sBAAsB;CACtB,gBAAgB;CAChB,2BAA2B;AAC5B;AACA;CACC,YAAY;AACb;AACA;CACC,wBAAwB;CACxB,eAAe;AAChB;AACA;CACC,WAAW;CACX,MAAM;AACP;AACA;CACC,UAAU;CACV,QAAQ;AACT;AACA;CACC,WAAW;CACX,SAAS;AACV;AACA;CACC,UAAU;CACV,OAAO;AACR;AACA;;;;CAIC,UAAU;CACV,WAAW;AACZ;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,OAAO;CACP,SAAS;AACV;AACA;CACC,QAAQ;CACR,MAAM;AACP;AACA;CACC,OAAO;CACP,MAAM;AACP;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,YAAY;AACb;AACA;CACC,mDAAyzE;CACzzE,YAAY;CACZ,yBAAyB,EAAE,iBAAiB;CAC5C,aAAa;AACd;AACA;CACC,sBAAsB;AACvB;AACA;CACC,UAAU;CACV,SAAS;CACT,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,aAAa;AACd;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,YAAY;CACZ,SAAS;AACV;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,YAAY;CACZ,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,aAAa;CACb,eAAe;CACf,sBAAsB;CACtB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,cAAc;CACd,SAAS;CACT,wBAAwB;AACzB;;AAEA,6BAA6B;AAC7B;;CAEC,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;AACA;CACC,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,MAAM;CACN,YAAY;AACb;AACA;CACC,OAAO;AACR;AACA;CACC,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,aAAa;AACd;AACA;CACC,WAAW;CACX,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,OAAO;CACP,WAAW;AACZ;AACA;CACC,SAAS;AACV;AACA;CACC,MAAM;AACP;AACA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,UAAU;CACV,sBAAsB;AACvB;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,cAAc;CACd,sBAAsB;CACtB,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;CACf,UAAU;CACV,SAAS;CACT,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,QAAQ;AACT;AACA,+DAA+D;AAC/D;CACC,sBAAsB;CACtB,yBAAyB;CACzB,wBAAwB;AACzB;AACA;CACC,MAAM;AACP;AACA;CACC,SAAS;AACV;AACA;CACC,kBAAkB,CAAC,uIAAuI;CAC1J,aAAa;AACd;AACA;CACC,SAAS;CACT,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,oBAAoB;CACpB,sBAAsB;CACtB,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;AACA;;;CAGC,YAAY;AACb;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB","sourcesContent":["/*!\r\n * jQuery UI CSS Framework 1.12.1\r\n * http://jqueryui.com\r\n *\r\n * Copyright jQuery Foundation and other contributors\r\n * Released under the MIT license.\r\n * http://jquery.org/license\r\n *\r\n * http://api.jqueryui.com/category/theming/\r\n */\r\n.ui-draggable-handle {\r\n\t-ms-touch-action: none;\r\n\ttouch-action: none;\r\n}\r\n/* Layout helpers\r\n----------------------------------*/\r\n.ui-helper-hidden {\r\n\tdisplay: none;\r\n}\r\n.ui-helper-hidden-accessible {\r\n\tborder: 0;\r\n\tclip: rect(0 0 0 0);\r\n\theight: 1px;\r\n\tmargin: -1px;\r\n\toverflow: hidden;\r\n\tpadding: 0;\r\n\tposition: absolute;\r\n\twidth: 1px;\r\n}\r\n.ui-helper-reset {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tborder: 0;\r\n\toutline: 0;\r\n\tline-height: 1.3;\r\n\ttext-decoration: none;\r\n\tfont-size: 100%;\r\n\tlist-style: none;\r\n}\r\n.ui-helper-clearfix:before,\r\n.ui-helper-clearfix:after {\r\n\tcontent: \"\";\r\n\tdisplay: table;\r\n\tborder-collapse: collapse;\r\n}\r\n.ui-helper-clearfix:after {\r\n\tclear: both;\r\n}\r\n.ui-helper-zfix {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tposition: absolute;\r\n\topacity: 0;\r\n\tfilter:Alpha(Opacity=0); /* support: IE8 */\r\n}\r\n\r\n.ui-front {\r\n\tz-index: 100;\r\n}\r\n\r\n\r\n/* Interaction Cues\r\n----------------------------------*/\r\n.ui-state-disabled {\r\n\tcursor: default !important;\r\n\tpointer-events: none;\r\n}\r\n\r\n\r\n/* Icons\r\n----------------------------------*/\r\n.ui-icon {\r\n\tdisplay: inline-block;\r\n\tvertical-align: middle;\r\n\tmargin-top: -.25em;\r\n\tposition: relative;\r\n\ttext-indent: -99999px;\r\n\toverflow: hidden;\r\n\tbackground-repeat: no-repeat;\r\n}\r\n\r\n.ui-widget-icon-block {\r\n\tleft: 50%;\r\n\tmargin-left: -8px;\r\n\tdisplay: block;\r\n}\r\n\r\n/* Misc visuals\r\n----------------------------------*/\r\n\r\n/* Overlays */\r\n.ui-widget-overlay {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n.ui-resizable {\r\n\tposition: relative;\r\n}\r\n.ui-resizable-handle {\r\n\tposition: absolute;\r\n\tfont-size: 0.1px;\r\n\tdisplay: block;\r\n\t-ms-touch-action: none;\r\n\ttouch-action: none;\r\n}\r\n.ui-resizable-disabled .ui-resizable-handle,\r\n.ui-resizable-autohide .ui-resizable-handle {\r\n\tdisplay: none;\r\n}\r\n.ui-resizable-n {\r\n\tcursor: n-resize;\r\n\theight: 7px;\r\n\twidth: 100%;\r\n\ttop: -5px;\r\n\tleft: 0;\r\n}\r\n.ui-resizable-s {\r\n\tcursor: s-resize;\r\n\theight: 7px;\r\n\twidth: 100%;\r\n\tbottom: -5px;\r\n\tleft: 0;\r\n}\r\n.ui-resizable-e {\r\n\tcursor: e-resize;\r\n\twidth: 7px;\r\n\tright: -5px;\r\n\ttop: 0;\r\n\theight: 100%;\r\n}\r\n.ui-resizable-w {\r\n\tcursor: w-resize;\r\n\twidth: 7px;\r\n\tleft: -5px;\r\n\ttop: 0;\r\n\theight: 100%;\r\n}\r\n.ui-resizable-se {\r\n\tcursor: se-resize;\r\n\twidth: 12px;\r\n\theight: 12px;\r\n\tright: 1px;\r\n\tbottom: 1px;\r\n}\r\n.ui-resizable-sw {\r\n\tcursor: sw-resize;\r\n\twidth: 9px;\r\n\theight: 9px;\r\n\tleft: -5px;\r\n\tbottom: -5px;\r\n}\r\n.ui-resizable-nw {\r\n\tcursor: nw-resize;\r\n\twidth: 9px;\r\n\theight: 9px;\r\n\tleft: -5px;\r\n\ttop: -5px;\r\n}\r\n.ui-resizable-ne {\r\n\tcursor: ne-resize;\r\n\twidth: 9px;\r\n\theight: 9px;\r\n\tright: -5px;\r\n\ttop: -5px;\r\n}\r\n.ui-selectable {\r\n\t-ms-touch-action: none;\r\n\ttouch-action: none;\r\n}\r\n.ui-selectable-helper {\r\n\tposition: absolute;\r\n\tz-index: 100;\r\n\tborder: 1px dotted black;\r\n}\r\n.ui-sortable-handle {\r\n\t-ms-touch-action: none;\r\n\ttouch-action: none;\r\n}\r\n.ui-accordion .ui-accordion-header {\r\n\tdisplay: block;\r\n\tcursor: pointer;\r\n\tposition: relative;\r\n\tmargin: 2px 0 0 0;\r\n\tpadding: .5em .5em .5em .7em;\r\n\tfont-size: 100%;\r\n}\r\n.ui-accordion .ui-accordion-content {\r\n\tpadding: 1em 2.2em;\r\n\tborder-top: 0;\r\n\toverflow: auto;\r\n}\r\n.ui-autocomplete {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tcursor: default;\r\n}\r\n.ui-menu {\r\n\tlist-style: none;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tdisplay: block;\r\n\toutline: 0;\r\n}\r\n.ui-menu .ui-menu {\r\n\tposition: absolute;\r\n}\r\n.ui-menu .ui-menu-item {\r\n\tmargin: 0;\r\n\tcursor: pointer;\r\n\t/* support: IE10, see #8844 */\r\n\tlist-style-image: url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\");\r\n}\r\n.ui-menu .ui-menu-item-wrapper {\r\n\tposition: relative;\r\n\tpadding: 3px 1em 3px .4em;\r\n}\r\n.ui-menu .ui-menu-divider {\r\n\tmargin: 5px 0;\r\n\theight: 0;\r\n\tfont-size: 0;\r\n\tline-height: 0;\r\n\tborder-width: 1px 0 0 0;\r\n}\r\n.ui-menu .ui-state-focus,\r\n.ui-menu .ui-state-active {\r\n\tmargin: -1px;\r\n}\r\n\r\n/* icon support */\r\n.ui-menu-icons {\r\n\tposition: relative;\r\n}\r\n.ui-menu-icons .ui-menu-item-wrapper {\r\n\tpadding-left: 2em;\r\n}\r\n\r\n/* left-aligned */\r\n.ui-menu .ui-icon {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: .2em;\r\n\tmargin: auto 0;\r\n}\r\n\r\n/* right-aligned */\r\n.ui-menu .ui-menu-icon {\r\n\tleft: auto;\r\n\tright: 0;\r\n}\r\n.ui-button {\r\n\tpadding: .4em 1em;\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n\tline-height: normal;\r\n\tmargin-right: .1em;\r\n\tcursor: pointer;\r\n\tvertical-align: middle;\r\n\ttext-align: center;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\r\n\t/* Support: IE <= 11 */\r\n\toverflow: visible;\r\n}\r\n\r\n.ui-button,\r\n.ui-button:link,\r\n.ui-button:visited,\r\n.ui-button:hover,\r\n.ui-button:active {\r\n\ttext-decoration: none;\r\n}\r\n\r\n/* to make room for the icon, a width needs to be set here */\r\n.ui-button-icon-only {\r\n\twidth: 2em;\r\n\tbox-sizing: border-box;\r\n\ttext-indent: -9999px;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n/* no icon support for input elements */\r\ninput.ui-button.ui-button-icon-only {\r\n\ttext-indent: 0;\r\n}\r\n\r\n/* button icon element(s) */\r\n.ui-button-icon-only .ui-icon {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\tmargin-top: -8px;\r\n\tmargin-left: -8px;\r\n}\r\n\r\n.ui-button.ui-icon-notext .ui-icon {\r\n\tpadding: 0;\r\n\twidth: 2.1em;\r\n\theight: 2.1em;\r\n\ttext-indent: -9999px;\r\n\twhite-space: nowrap;\r\n\r\n}\r\n\r\ninput.ui-button.ui-icon-notext .ui-icon {\r\n\twidth: auto;\r\n\theight: auto;\r\n\ttext-indent: 0;\r\n\twhite-space: normal;\r\n\tpadding: .4em 1em;\r\n}\r\n\r\n/* workarounds */\r\n/* Support: Firefox 5 - 40 */\r\ninput.ui-button::-moz-focus-inner,\r\nbutton.ui-button::-moz-focus-inner {\r\n\tborder: 0;\r\n\tpadding: 0;\r\n}\r\n.ui-controlgroup {\r\n\tvertical-align: middle;\r\n\tdisplay: inline-block;\r\n}\r\n.ui-controlgroup > .ui-controlgroup-item {\r\n\tfloat: left;\r\n\tmargin-left: 0;\r\n\tmargin-right: 0;\r\n}\r\n.ui-controlgroup > .ui-controlgroup-item:focus,\r\n.ui-controlgroup > .ui-controlgroup-item.ui-visual-focus {\r\n\tz-index: 9999;\r\n}\r\n.ui-controlgroup-vertical > .ui-controlgroup-item {\r\n\tdisplay: block;\r\n\tfloat: none;\r\n\twidth: 100%;\r\n\tmargin-top: 0;\r\n\tmargin-bottom: 0;\r\n\ttext-align: left;\r\n}\r\n.ui-controlgroup-vertical .ui-controlgroup-item {\r\n\tbox-sizing: border-box;\r\n}\r\n.ui-controlgroup .ui-controlgroup-label {\r\n\tpadding: .4em 1em;\r\n}\r\n.ui-controlgroup .ui-controlgroup-label span {\r\n\tfont-size: 80%;\r\n}\r\n.ui-controlgroup-horizontal .ui-controlgroup-label + .ui-controlgroup-item {\r\n\tborder-left: none;\r\n}\r\n.ui-controlgroup-vertical .ui-controlgroup-label + .ui-controlgroup-item {\r\n\tborder-top: none;\r\n}\r\n.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {\r\n\tborder-right: none;\r\n}\r\n.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {\r\n\tborder-bottom: none;\r\n}\r\n\r\n/* Spinner specific style fixes */\r\n.ui-controlgroup-vertical .ui-spinner-input {\r\n\r\n\t/* Support: IE8 only, Android < 4.4 only */\r\n\twidth: 75%;\r\n\twidth: calc( 100% - 2.4em );\r\n}\r\n.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {\r\n\tborder-top-style: solid;\r\n}\r\n\r\n.ui-checkboxradio-label .ui-icon-background {\r\n\tbox-shadow: inset 1px 1px 1px #ccc;\r\n\tborder-radius: .12em;\r\n\tborder: none;\r\n}\r\n.ui-checkboxradio-radio-label .ui-icon-background {\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tborder-radius: 1em;\r\n\toverflow: visible;\r\n\tborder: none;\r\n}\r\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,\r\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {\r\n\tbackground-image: none;\r\n\twidth: 8px;\r\n\theight: 8px;\r\n\tborder-width: 4px;\r\n\tborder-style: solid;\r\n}\r\n.ui-checkboxradio-disabled {\r\n\tpointer-events: none;\r\n}\r\n.ui-datepicker {\r\n\twidth: 17em;\r\n\tpadding: .2em .2em 0;\r\n\tdisplay: none;\r\n}\r\n.ui-datepicker .ui-datepicker-header {\r\n\tposition: relative;\r\n\tpadding: .2em 0;\r\n}\r\n.ui-datepicker .ui-datepicker-prev,\r\n.ui-datepicker .ui-datepicker-next {\r\n\tposition: absolute;\r\n\ttop: 2px;\r\n\twidth: 1.8em;\r\n\theight: 1.8em;\r\n}\r\n.ui-datepicker .ui-datepicker-prev-hover,\r\n.ui-datepicker .ui-datepicker-next-hover {\r\n\ttop: 1px;\r\n}\r\n.ui-datepicker .ui-datepicker-prev {\r\n\tleft: 2px;\r\n}\r\n.ui-datepicker .ui-datepicker-next {\r\n\tright: 2px;\r\n}\r\n.ui-datepicker .ui-datepicker-prev-hover {\r\n\tleft: 1px;\r\n}\r\n.ui-datepicker .ui-datepicker-next-hover {\r\n\tright: 1px;\r\n}\r\n.ui-datepicker .ui-datepicker-prev span,\r\n.ui-datepicker .ui-datepicker-next span {\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\tmargin-left: -8px;\r\n\ttop: 50%;\r\n\tmargin-top: -8px;\r\n}\r\n.ui-datepicker .ui-datepicker-title {\r\n\tmargin: 0 2.3em;\r\n\tline-height: 1.8em;\r\n\ttext-align: center;\r\n}\r\n.ui-datepicker .ui-datepicker-title select {\r\n\tfont-size: 1em;\r\n\tmargin: 1px 0;\r\n}\r\n.ui-datepicker select.ui-datepicker-month,\r\n.ui-datepicker select.ui-datepicker-year {\r\n\twidth: 45%;\r\n}\r\n.ui-datepicker table {\r\n\twidth: 100%;\r\n\tfont-size: .9em;\r\n\tborder-collapse: collapse;\r\n\tmargin: 0 0 .4em;\r\n}\r\n.ui-datepicker th {\r\n\tpadding: .7em .3em;\r\n\ttext-align: center;\r\n\tfont-weight: bold;\r\n\tborder: 0;\r\n}\r\n.ui-datepicker td {\r\n\tborder: 0;\r\n\tpadding: 1px;\r\n}\r\n.ui-datepicker td span,\r\n.ui-datepicker td a {\r\n\tdisplay: block;\r\n\tpadding: .2em;\r\n\ttext-align: right;\r\n\ttext-decoration: none;\r\n}\r\n.ui-datepicker .ui-datepicker-buttonpane {\r\n\tbackground-image: none;\r\n\tmargin: .7em 0 0 0;\r\n\tpadding: 0 .2em;\r\n\tborder-left: 0;\r\n\tborder-right: 0;\r\n\tborder-bottom: 0;\r\n}\r\n.ui-datepicker .ui-datepicker-buttonpane button {\r\n\tfloat: right;\r\n\tmargin: .5em .2em .4em;\r\n\tcursor: pointer;\r\n\tpadding: .2em .6em .3em .6em;\r\n\twidth: auto;\r\n\toverflow: visible;\r\n}\r\n.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {\r\n\tfloat: left;\r\n}\r\n\r\n/* with multiple calendars */\r\n.ui-datepicker.ui-datepicker-multi {\r\n\twidth: auto;\r\n}\r\n.ui-datepicker-multi .ui-datepicker-group {\r\n\tfloat: left;\r\n}\r\n.ui-datepicker-multi .ui-datepicker-group table {\r\n\twidth: 95%;\r\n\tmargin: 0 auto .4em;\r\n}\r\n.ui-datepicker-multi-2 .ui-datepicker-group {\r\n\twidth: 50%;\r\n}\r\n.ui-datepicker-multi-3 .ui-datepicker-group {\r\n\twidth: 33.3%;\r\n}\r\n.ui-datepicker-multi-4 .ui-datepicker-group {\r\n\twidth: 25%;\r\n}\r\n.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,\r\n.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {\r\n\tborder-left-width: 0;\r\n}\r\n.ui-datepicker-multi .ui-datepicker-buttonpane {\r\n\tclear: left;\r\n}\r\n.ui-datepicker-row-break {\r\n\tclear: both;\r\n\twidth: 100%;\r\n\tfont-size: 0;\r\n}\r\n\r\n/* RTL support */\r\n.ui-datepicker-rtl {\r\n\tdirection: rtl;\r\n}\r\n.ui-datepicker-rtl .ui-datepicker-prev {\r\n\tright: 2px;\r\n\tleft: auto;\r\n}\r\n.ui-datepicker-rtl .ui-datepicker-next {\r\n\tleft: 2px;\r\n\tright: auto;\r\n}\r\n.ui-datepicker-rtl .ui-datepicker-prev:hover {\r\n\tright: 1px;\r\n\tleft: auto;\r\n}\r\n.ui-datepicker-rtl .ui-datepicker-next:hover {\r\n\tleft: 1px;\r\n\tright: auto;\r\n}\r\n.ui-datepicker-rtl .ui-datepicker-buttonpane {\r\n\tclear: right;\r\n}\r\n.ui-datepicker-rtl .ui-datepicker-buttonpane button {\r\n\tfloat: left;\r\n}\r\n.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,\r\n.ui-datepicker-rtl .ui-datepicker-group {\r\n\tfloat: right;\r\n}\r\n.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,\r\n.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {\r\n\tborder-right-width: 0;\r\n\tborder-left-width: 1px;\r\n}\r\n\r\n/* Icons */\r\n.ui-datepicker .ui-icon {\r\n\tdisplay: block;\r\n\ttext-indent: -99999px;\r\n\toverflow: hidden;\r\n\tbackground-repeat: no-repeat;\r\n\tleft: .5em;\r\n\ttop: .3em;\r\n}\r\n.ui-dialog {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tpadding: .2em;\r\n\toutline: 0;\r\n}\r\n.ui-dialog .ui-dialog-titlebar {\r\n\tpadding: .4em 1em;\r\n\tposition: relative;\r\n}\r\n.ui-dialog .ui-dialog-title {\r\n\tfloat: left;\r\n\tmargin: .1em 0;\r\n\twhite-space: nowrap;\r\n\twidth: 90%;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n}\r\n.ui-dialog .ui-dialog-titlebar-close {\r\n\tposition: absolute;\r\n\tright: .3em;\r\n\ttop: 50%;\r\n\twidth: 20px;\r\n\tmargin: -10px 0 0 0;\r\n\tpadding: 1px;\r\n\theight: 20px;\r\n}\r\n.ui-dialog .ui-dialog-content {\r\n\tposition: relative;\r\n\tborder: 0;\r\n\tpadding: .5em 1em;\r\n\tbackground: none;\r\n\toverflow: auto;\r\n}\r\n.ui-dialog .ui-dialog-buttonpane {\r\n\ttext-align: left;\r\n\tborder-width: 1px 0 0 0;\r\n\tbackground-image: none;\r\n\tmargin-top: .5em;\r\n\tpadding: .3em 1em .5em .4em;\r\n}\r\n.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {\r\n\tfloat: right;\r\n}\r\n.ui-dialog .ui-dialog-buttonpane button {\r\n\tmargin: .5em .4em .5em 0;\r\n\tcursor: pointer;\r\n}\r\n.ui-dialog .ui-resizable-n {\r\n\theight: 2px;\r\n\ttop: 0;\r\n}\r\n.ui-dialog .ui-resizable-e {\r\n\twidth: 2px;\r\n\tright: 0;\r\n}\r\n.ui-dialog .ui-resizable-s {\r\n\theight: 2px;\r\n\tbottom: 0;\r\n}\r\n.ui-dialog .ui-resizable-w {\r\n\twidth: 2px;\r\n\tleft: 0;\r\n}\r\n.ui-dialog .ui-resizable-se,\r\n.ui-dialog .ui-resizable-sw,\r\n.ui-dialog .ui-resizable-ne,\r\n.ui-dialog .ui-resizable-nw {\r\n\twidth: 7px;\r\n\theight: 7px;\r\n}\r\n.ui-dialog .ui-resizable-se {\r\n\tright: 0;\r\n\tbottom: 0;\r\n}\r\n.ui-dialog .ui-resizable-sw {\r\n\tleft: 0;\r\n\tbottom: 0;\r\n}\r\n.ui-dialog .ui-resizable-ne {\r\n\tright: 0;\r\n\ttop: 0;\r\n}\r\n.ui-dialog .ui-resizable-nw {\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n.ui-draggable .ui-dialog-titlebar {\r\n\tcursor: move;\r\n}\r\n.ui-progressbar {\r\n\theight: 2em;\r\n\ttext-align: left;\r\n\toverflow: hidden;\r\n}\r\n.ui-progressbar .ui-progressbar-value {\r\n\tmargin: -1px;\r\n\theight: 100%;\r\n}\r\n.ui-progressbar .ui-progressbar-overlay {\r\n\tbackground: url(\"data:image/gif;base64,R0lGODlhKAAoAIABAAAAAP///yH/C05FVFNDQVBFMi4wAwEAAAAh+QQJAQABACwAAAAAKAAoAAACkYwNqXrdC52DS06a7MFZI+4FHBCKoDeWKXqymPqGqxvJrXZbMx7Ttc+w9XgU2FB3lOyQRWET2IFGiU9m1frDVpxZZc6bfHwv4c1YXP6k1Vdy292Fb6UkuvFtXpvWSzA+HycXJHUXiGYIiMg2R6W459gnWGfHNdjIqDWVqemH2ekpObkpOlppWUqZiqr6edqqWQAAIfkECQEAAQAsAAAAACgAKAAAApSMgZnGfaqcg1E2uuzDmmHUBR8Qil95hiPKqWn3aqtLsS18y7G1SzNeowWBENtQd+T1JktP05nzPTdJZlR6vUxNWWjV+vUWhWNkWFwxl9VpZRedYcflIOLafaa28XdsH/ynlcc1uPVDZxQIR0K25+cICCmoqCe5mGhZOfeYSUh5yJcJyrkZWWpaR8doJ2o4NYq62lAAACH5BAkBAAEALAAAAAAoACgAAAKVDI4Yy22ZnINRNqosw0Bv7i1gyHUkFj7oSaWlu3ovC8GxNso5fluz3qLVhBVeT/Lz7ZTHyxL5dDalQWPVOsQWtRnuwXaFTj9jVVh8pma9JjZ4zYSj5ZOyma7uuolffh+IR5aW97cHuBUXKGKXlKjn+DiHWMcYJah4N0lYCMlJOXipGRr5qdgoSTrqWSq6WFl2ypoaUAAAIfkECQEAAQAsAAAAACgAKAAAApaEb6HLgd/iO7FNWtcFWe+ufODGjRfoiJ2akShbueb0wtI50zm02pbvwfWEMWBQ1zKGlLIhskiEPm9R6vRXxV4ZzWT2yHOGpWMyorblKlNp8HmHEb/lCXjcW7bmtXP8Xt229OVWR1fod2eWqNfHuMjXCPkIGNileOiImVmCOEmoSfn3yXlJWmoHGhqp6ilYuWYpmTqKUgAAIfkECQEAAQAsAAAAACgAKAAAApiEH6kb58biQ3FNWtMFWW3eNVcojuFGfqnZqSebuS06w5V80/X02pKe8zFwP6EFWOT1lDFk8rGERh1TTNOocQ61Hm4Xm2VexUHpzjymViHrFbiELsefVrn6XKfnt2Q9G/+Xdie499XHd2g4h7ioOGhXGJboGAnXSBnoBwKYyfioubZJ2Hn0RuRZaflZOil56Zp6iioKSXpUAAAh+QQJAQABACwAAAAAKAAoAAACkoQRqRvnxuI7kU1a1UU5bd5tnSeOZXhmn5lWK3qNTWvRdQxP8qvaC+/yaYQzXO7BMvaUEmJRd3TsiMAgswmNYrSgZdYrTX6tSHGZO73ezuAw2uxuQ+BbeZfMxsexY35+/Qe4J1inV0g4x3WHuMhIl2jXOKT2Q+VU5fgoSUI52VfZyfkJGkha6jmY+aaYdirq+lQAACH5BAkBAAEALAAAAAAoACgAAAKWBIKpYe0L3YNKToqswUlvznigd4wiR4KhZrKt9Upqip61i9E3vMvxRdHlbEFiEXfk9YARYxOZZD6VQ2pUunBmtRXo1Lf8hMVVcNl8JafV38aM2/Fu5V16Bn63r6xt97j09+MXSFi4BniGFae3hzbH9+hYBzkpuUh5aZmHuanZOZgIuvbGiNeomCnaxxap2upaCZsq+1kAACH5BAkBAAEALAAAAAAoACgAAAKXjI8By5zf4kOxTVrXNVlv1X0d8IGZGKLnNpYtm8Lr9cqVeuOSvfOW79D9aDHizNhDJidFZhNydEahOaDH6nomtJjp1tutKoNWkvA6JqfRVLHU/QUfau9l2x7G54d1fl995xcIGAdXqMfBNadoYrhH+Mg2KBlpVpbluCiXmMnZ2Sh4GBqJ+ckIOqqJ6LmKSllZmsoq6wpQAAAh+QQJAQABACwAAAAAKAAoAAAClYx/oLvoxuJDkU1a1YUZbJ59nSd2ZXhWqbRa2/gF8Gu2DY3iqs7yrq+xBYEkYvFSM8aSSObE+ZgRl1BHFZNr7pRCavZ5BW2142hY3AN/zWtsmf12p9XxxFl2lpLn1rseztfXZjdIWIf2s5dItwjYKBgo9yg5pHgzJXTEeGlZuenpyPmpGQoKOWkYmSpaSnqKileI2FAAACH5BAkBAAEALAAAAAAoACgAAAKVjB+gu+jG4kORTVrVhRlsnn2dJ3ZleFaptFrb+CXmO9OozeL5VfP99HvAWhpiUdcwkpBH3825AwYdU8xTqlLGhtCosArKMpvfa1mMRae9VvWZfeB2XfPkeLmm18lUcBj+p5dnN8jXZ3YIGEhYuOUn45aoCDkp16hl5IjYJvjWKcnoGQpqyPlpOhr3aElaqrq56Bq7VAAAOw==\");\r\n\theight: 100%;\r\n\tfilter: alpha(opacity=25); /* support: IE8 */\r\n\topacity: 0.25;\r\n}\r\n.ui-progressbar-indeterminate .ui-progressbar-value {\r\n\tbackground-image: none;\r\n}\r\n.ui-selectmenu-menu {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tdisplay: none;\r\n}\r\n.ui-selectmenu-menu .ui-menu {\r\n\toverflow: auto;\r\n\toverflow-x: hidden;\r\n\tpadding-bottom: 1px;\r\n}\r\n.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {\r\n\tfont-size: 1em;\r\n\tfont-weight: bold;\r\n\tline-height: 1.5;\r\n\tpadding: 2px 0.4em;\r\n\tmargin: 0.5em 0 0 0;\r\n\theight: auto;\r\n\tborder: 0;\r\n}\r\n.ui-selectmenu-open {\r\n\tdisplay: block;\r\n}\r\n.ui-selectmenu-text {\r\n\tdisplay: block;\r\n\tmargin-right: 20px;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n}\r\n.ui-selectmenu-button.ui-button {\r\n\ttext-align: left;\r\n\twhite-space: nowrap;\r\n\twidth: 14em;\r\n}\r\n.ui-selectmenu-icon.ui-icon {\r\n\tfloat: right;\r\n\tmargin-top: 0;\r\n}\r\n.ui-slider {\r\n\tposition: relative;\r\n\ttext-align: left;\r\n}\r\n.ui-slider .ui-slider-handle {\r\n\tposition: absolute;\r\n\tz-index: 2;\r\n\twidth: 1.2em;\r\n\theight: 1.2em;\r\n\tcursor: default;\r\n\t-ms-touch-action: none;\r\n\ttouch-action: none;\r\n}\r\n.ui-slider .ui-slider-range {\r\n\tposition: absolute;\r\n\tz-index: 1;\r\n\tfont-size: .7em;\r\n\tdisplay: block;\r\n\tborder: 0;\r\n\tbackground-position: 0 0;\r\n}\r\n\r\n/* support: IE8 - See #6727 */\r\n.ui-slider.ui-state-disabled .ui-slider-handle,\r\n.ui-slider.ui-state-disabled .ui-slider-range {\r\n\tfilter: inherit;\r\n}\r\n\r\n.ui-slider-horizontal {\r\n\theight: .8em;\r\n}\r\n.ui-slider-horizontal .ui-slider-handle {\r\n\ttop: -.3em;\r\n\tmargin-left: -.6em;\r\n}\r\n.ui-slider-horizontal .ui-slider-range {\r\n\ttop: 0;\r\n\theight: 100%;\r\n}\r\n.ui-slider-horizontal .ui-slider-range-min {\r\n\tleft: 0;\r\n}\r\n.ui-slider-horizontal .ui-slider-range-max {\r\n\tright: 0;\r\n}\r\n\r\n.ui-slider-vertical {\r\n\twidth: .8em;\r\n\theight: 100px;\r\n}\r\n.ui-slider-vertical .ui-slider-handle {\r\n\tleft: -.3em;\r\n\tmargin-left: 0;\r\n\tmargin-bottom: -.6em;\r\n}\r\n.ui-slider-vertical .ui-slider-range {\r\n\tleft: 0;\r\n\twidth: 100%;\r\n}\r\n.ui-slider-vertical .ui-slider-range-min {\r\n\tbottom: 0;\r\n}\r\n.ui-slider-vertical .ui-slider-range-max {\r\n\ttop: 0;\r\n}\r\n.ui-spinner {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\toverflow: hidden;\r\n\tpadding: 0;\r\n\tvertical-align: middle;\r\n}\r\n.ui-spinner-input {\r\n\tborder: none;\r\n\tbackground: none;\r\n\tcolor: inherit;\r\n\tpadding: .222em 0;\r\n\tmargin: .2em 0;\r\n\tvertical-align: middle;\r\n\tmargin-left: .4em;\r\n\tmargin-right: 2em;\r\n}\r\n.ui-spinner-button {\r\n\twidth: 1.6em;\r\n\theight: 50%;\r\n\tfont-size: .5em;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\ttext-align: center;\r\n\tposition: absolute;\r\n\tcursor: default;\r\n\tdisplay: block;\r\n\toverflow: hidden;\r\n\tright: 0;\r\n}\r\n/* more specificity required here to override default borders */\r\n.ui-spinner a.ui-spinner-button {\r\n\tborder-top-style: none;\r\n\tborder-bottom-style: none;\r\n\tborder-right-style: none;\r\n}\r\n.ui-spinner-up {\r\n\ttop: 0;\r\n}\r\n.ui-spinner-down {\r\n\tbottom: 0;\r\n}\r\n.ui-tabs {\r\n\tposition: relative;/* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as \"fixed\") */\r\n\tpadding: .2em;\r\n}\r\n.ui-tabs .ui-tabs-nav {\r\n\tmargin: 0;\r\n\tpadding: .2em .2em 0;\r\n}\r\n.ui-tabs .ui-tabs-nav li {\r\n\tlist-style: none;\r\n\tfloat: left;\r\n\tposition: relative;\r\n\ttop: 0;\r\n\tmargin: 1px .2em 0 0;\r\n\tborder-bottom-width: 0;\r\n\tpadding: 0;\r\n\twhite-space: nowrap;\r\n}\r\n.ui-tabs .ui-tabs-nav .ui-tabs-anchor {\r\n\tfloat: left;\r\n\tpadding: .5em 1em;\r\n\ttext-decoration: none;\r\n}\r\n.ui-tabs .ui-tabs-nav li.ui-tabs-active {\r\n\tmargin-bottom: -1px;\r\n\tpadding-bottom: 1px;\r\n}\r\n.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,\r\n.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,\r\n.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {\r\n\tcursor: text;\r\n}\r\n.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {\r\n\tcursor: pointer;\r\n}\r\n.ui-tabs .ui-tabs-panel {\r\n\tdisplay: block;\r\n\tborder-width: 0;\r\n\tpadding: 1em 1.4em;\r\n\tbackground: none;\r\n}\r\n.ui-tooltip {\r\n\tpadding: 8px;\r\n\tposition: absolute;\r\n\tz-index: 9999;\r\n\tmax-width: 300px;\r\n}\r\nbody .ui-tooltip {\r\n\tborder-width: 2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
